// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import draftArticleEntity from './entities/draft-article.json';
import draftArticleMenu from '../pages/draft-article/menu.json';
import draftArticleFullForm from '../pages/draft-article/forms/full.json';
import draftArticleContextForm from '../pages/draft-article/forms/context.json';
import draftArticleMiniForm from '../pages/draft-article/forms/mini.json';
import draftArticleLookupForm from '../pages/draft-article/forms/lookup.json';
import draftArticleTableView from '../pages/draft-article/views/table.json';
import draftArticleCardsView from '../pages/draft-article/views/cards.json';
import draftArticleDashboardView from '../pages/draft-article/views/dashboard.json';

/** Тип запису «Стаття проєкту» зі сторінками пакета: меню, форми та подання з pages/draft-article/. */
export const draftArticleDefinition: IRecordTypeDefinition = {
  ...draftArticleEntity,
  views: assembleViewSet({
      table: draftArticleTableView,
      cards: draftArticleCardsView,
      dashboard: draftArticleDashboardView,
  }),
  form: draftArticleFullForm,
  forms: { full: draftArticleFullForm, context: draftArticleContextForm, mini: draftArticleMiniForm, lookup: draftArticleLookupForm },
  menu: draftArticleMenu,
} as IRecordTypeDefinition;
